// libraries
import React from 'react';
import styled from 'styled-components';

// styled components
import { H3, Text } from 'shared/typography';
import { Flex, ColumnedFlex } from 'shared/styledComponents';

// styles
import devices from 'theme/devices';

const Wrapper = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  background-color: ${({ theme: { colors } }): string => colors.secondary};
  padding: 60px 55px;
  margin-bottom: 40px;
  @media ${devices.mobile} {
    margin: auto;
    flex-direction: column;
    padding: 0;
  }
`;

const JourneyInfo = styled(ColumnedFlex)`
  max-width: 440px;
  margin-top: 70px;
  margin-left: 50px;

  @media ${devices.mobile} {
    margin: 0;
    margin-bottom: 55px;
    padding: 55px 55px 0;
  }
`;

const Heading = styled(H3)<any>`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 185px;
  font-family: ${({ theme: { fonts } }): string => fonts.canelaThinItalic};
  margin-bottom: 30px;
  cursor: pointer;
  line-height: 46px;

  @media ${devices.mobile} {
    -webkit-line-clamp: 4;
    height: 140px;
    margin-bottom: 35px;
    text-align: center;
  }
`;

const StyledText = styled(Text)`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100px;

  @media ${devices.mobile} {
    -webkit-line-clamp: 3;
    height: 75px;
    text-align: center;
  }
`;

const ImageWrapper = styled.div<any>`
  width: 430px;
  height: 430px;
  background-image: ${({ src }): string => `url(${src})`};
  background-position: center;
  background-size: cover;
  background-position-y: 0;
  background-repeat: no-repeat;
  cursor: pointer;

  @media ${devices.mobile} {
    width: 100%;
    height: 310px;
  }
`;

interface RealStoryPreviewProps {
  url: string;
  featuredQuote: string;
  subtitle: string;
  photoUrl?: string;
  onStoryClick: (url: string) => () => void;
}

const RealStoryPreview = ({
  url,
  featuredQuote,
  subtitle,
  photoUrl,
  onStoryClick,
}: RealStoryPreviewProps): JSX.Element => (
  <Wrapper>
    <JourneyInfo>
      <Heading as="q" onClick={onStoryClick(url)}>
        {featuredQuote}
      </Heading>
      <StyledText>{subtitle}</StyledText>
    </JourneyInfo>
    <ImageWrapper data-bg={photoUrl} onClick={onStoryClick(url)} className="lazyload" />
  </Wrapper>
);

export default RealStoryPreview;
